export var ColSize;
(function (ColSize) {
    ColSize["Auto"] = "auto";
    ColSize["One"] = "1";
    ColSize["Two"] = "2";
    ColSize["Three"] = "3";
    ColSize["Four"] = "4";
    ColSize["Five"] = "5";
    ColSize["Six"] = "6";
    ColSize["Seven"] = "7";
    ColSize["Eight"] = "8";
    ColSize["Nine"] = "9";
    ColSize["Ten"] = "10";
    ColSize["Eleven"] = "11";
    ColSize["Twelve"] = "12";
})(ColSize || (ColSize = {}));
export var ColOffset;
(function (ColOffset) {
    ColOffset["None"] = "0";
    ColOffset["One"] = "1";
    ColOffset["Two"] = "2";
    ColOffset["Three"] = "3";
    ColOffset["Four"] = "4";
    ColOffset["Five"] = "5";
    ColOffset["Six"] = "6";
    ColOffset["Seven"] = "7";
    ColOffset["Eight"] = "8";
    ColOffset["Nine"] = "9";
    ColOffset["Ten"] = "10";
    ColOffset["Eleven"] = "11";
})(ColOffset || (ColOffset = {}));
export var ColAlignSelf;
(function (ColAlignSelf) {
    ColAlignSelf["Start"] = "start";
    ColAlignSelf["End"] = "end";
    ColAlignSelf["Center"] = "center";
    ColAlignSelf["Stretch"] = "stretch";
})(ColAlignSelf || (ColAlignSelf = {}));
export var ColCssClass;
(function (ColCssClass) {
    ColCssClass["Base"] = "iress-col";
})(ColCssClass || (ColCssClass = {}));
//# sourceMappingURL=col.types.js.map